import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    text: 'Descargas el protocolo directamente a tu móvil o tablet tras el pago.'
  }, {
    num: '2',
    text: 'Identificas los 5 alimentos "llamarada" que te están hinchando ahora mismo.'
  }, {
    num: '3',
    text: 'Aplicas el plan de 7 días y notas cómo la presión de tu cintura empieza a desaparecer.'
  }];
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-94">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-95">
        <FadeIn data-id="element-96">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] text-center mb-16" data-id="element-97">
            Cómo funciona:
          </h2>
        </FadeIn>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-8 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-[#E8EDE6]" data-id="element-98">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-99">
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-100">
                {/* Icon */}
                <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#FAF7F2] bg-[#4A6741] text-white font-serif text-2xl font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-101">
                  {step.num}
                </div>

                {/* Content */}
                <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] p-6 bg-white rounded-2xl shadow-sm border border-[#E8EDE6]" data-id="element-102">
                  <p className="text-lg text-[#6B6560] leading-relaxed" data-id="element-103">
                    {step.text}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}